import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from 'packages/@shopify/react-i18n';
import {ShopGrid} from 'components/ShopDisplay';
import {Grid, GridItem} from 'components/MarketingAssets';
import {FeaturedSection} from '../../Home';
import * as locales from './locales';

export interface FeaturedListingsProps {
  feature: FeaturedSection;
  first?: boolean;
}

const STYLES = {
  h3: 'heading--3',
  h4: 'heading--4',
  textBold: 'text-bold',
  headingInline: 'heading--inline',

  section: 'section',
  sectionTight: 'section--tight',
  sectionPaddingBottom: 'section--padding-bottom-only',

  sectionHeading: 'section-heading',
  sectionHeadingLeft: 'section-heading--left',
  sectionHeadingHeading: 'section-heading__heading',
  sectionHeadingSubheading: 'section-heading__subhead',

  gutterBottom: 'gutter-bottom',
  gutterBottomHalf: 'gutter-bottom--half',
  gutterBottomReset: 'gutter-bottom--reset',
};

const headerClass = classNames(
  STYLES.h3,
  STYLES.sectionHeadingHeading,
  STYLES.gutterBottomHalf,
  STYLES.headingInline,
);

const wrapperClass = classNames(
  STYLES.sectionHeading,
  STYLES.sectionHeadingLeft,
  STYLES.gutterBottom,
);

const paragraphClass = classNames(
  STYLES.sectionHeadingSubheading,
  STYLES.h4,
  STYLES.gutterBottomReset,
);

function FeaturedListingsComponent({
  first = false,
  feature,
  i18n,
}: FeaturedListingsProps & WithI18nProps) {
  const sectionClass = classNames(
    STYLES.section,
    STYLES.sectionTight,
    {[STYLES.sectionPaddingBottom]: !first},
  );

  return (
    <section className={sectionClass}>
      <Grid equalHeight>
        <GridItem className={STYLES.gutterBottomReset}>
          <div className={wrapperClass}>
            <a href={feature.linkUrl}>
              <h2 className={headerClass}>
                {i18n.translate(`${feature.key}.heading`)}
              </h2>
            </a>
            <p className={paragraphClass}>
              {i18n.translate(`${feature.key}.subhead`)}
            </p>
          </div>
        </GridItem>
      </Grid>
      <Grid equalHeight>
        <ShopGrid shops={feature.shops} />
      </Grid>
      <Grid equalHeight>
        <GridItem>
          <a className={STYLES.textBold} href={feature.linkUrl}>
            {i18n.translate('SeeMore', {replacements: {shopCount: feature.count}})}
          </a>
        </GridItem>
      </Grid>
    </section>
  );
}

export const FeaturedListings = withI18n({
  id: 'FeaturedListings',
  fallback: locales.en,
})(FeaturedListingsComponent);

export default FeaturedListings;
